import { http } from "@next-core/http";
/**
 * @description 创建活动记录
 * @endpoint POST /api/v1/elevo/spaces/:spaceId/activities
 */
export const ElevoSpaceApi_createActivityLog = async (spaceId, data, options) => /**! @contract easyops.api.llm.elevo_space.CreateActivityLog@1.0.0 */(await http.post(`api/gateway/logic.llm.aiops_service/api/v1/elevo/spaces/${spaceId}/activities`, data, options)).data;
//# sourceMappingURL=createActivityLog.js.map